export const defaultLimit = {
  fileLimit: 0,
  mimeTypes: [],
}
export const CHALLENGE_ID = process.env.REACT_APP_CHALLENGE_ID
